// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"50":"235ea3","850":"282e2d","858":"1b8e05","928":"e7ebba"}[chunkId] + ".js";
};